import BillingsOrderAddressesResponse, {
  BillingsOrderAddressesResponseData,
} from "../../../../api/raily/billings/order/addresses/billings-order-addresses.response";
import BillingsOrderAddresses, {
  BillingsOrderAddress,
} from "./billings-order-addresses";

const createAddress = (
  responseData: BillingsOrderAddressesResponseData,
): BillingsOrderAddress => {
  return {
    lat: responseData.lat,
    lon: responseData.lon,
    displayName: responseData.displayName,
  };
};

const create = (
  response: BillingsOrderAddressesResponse,
): BillingsOrderAddresses => {
  return response.data.map(createAddress);
};

const billingsOrderAddressesFactory = {
  create,
};

export default billingsOrderAddressesFactory;
